__webpack_require__.p = "/wp-content/themes/bexpo.ch/dist/";